// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__Efr_X","fileBtn":"File_fileBtn__2e_6E","closeBtn":"File_closeBtn__1TQ09","fileSelected":"File_fileSelected__zLjcF","disabled":"File_disabled__3VzAO"};